import $ from 'jquery';

$(document).ready(function() {
    $('.js-game-squares-slider').slick({
        dots: false,
        slidesToShow: 4,
        centerMode: false,
        variableWidth: true,
        arrows: true,
        infinite: false,
        draggable: false,
        responsive: [
        {
            breakpoint: 700,
            settings: {
                dots: false,
                slidesToShow: 2,
                centerMode: false,
                variableWidth: true,
                arrows: true,
                infinite: false,
                draggable: false,
           }
        }
        ]
    });
    $(window).trigger('resize');
});


// WEBPACK FOOTER //
// ./src/js/pages/game-loto/game-squares-slider.js